import { blackIdProps, listBlackProps, PostBlackProps } from "../types/blackList";
import { getHotelId, headers, querystring, removeNullInObject, request } from "./lib/common";

export const selectBlackList = ({id}:blackIdProps) => {
    return request.get(`/multifamily/hotels/${getHotelId()}/blackList/${id}`, headers({}));
}
  
export const listBlackList = ({hotel_id, room_no, offset, limit, pagination=true}:listBlackProps) => {
    return request.get(`/multifamily/hotels/${hotel_id? hotel_id : getHotelId()}/blackList`, {
        ...querystring({...room_no && {room_no}, offset, limit, pagination}),
        ...headers({}),
    });
}

export const createBlackList = ({ hotel_name, room_no, room_type_code}:PostBlackProps) => {
    const data = removeNullInObject({hotel_name, room_no, room_type_code});
    return request.post(`/multifamily/hotels/${getHotelId()}/blackList`,
        data,
        headers({}),
    );
}

export const updateBlackList = ({id, room_no, room_type_code}:PostBlackProps) => {
    let data = removeNullInObject({room_no, room_type_code});
    data={...data};
    return request.put(`/multifamily/hotels/${getHotelId()}/blackList/${id}`,
        data,
        headers({}),
    );
}

export const deleteBlackList = ({id}:blackIdProps) => {
    return request.delete(`/multifamily/hotels/${getHotelId()}/blackList/${id}`, headers({}));
}

// listBuilding, selectBuilding API 호출 값
export type listBlackApi = {
    "id": string,
    "room_type_code": string,
    "room_no": string,
    "hotel_id": string,
    "hotel_name": string,
    "created_at": Date,
    "updated_at": Date,
}